/* unplugin-vue-components disabled */import script from "./postDraftManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./postDraftManager.vue?vue&type=script&setup=true&lang=ts"

import "./postDraftManager.vue?vue&type=style&index=0&id=29f1be64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29f1be64"]])

export default __exports__